import React, { useEffect, useState } from "react";
import { Footer, Navbar } from "../components";
import { useSelector, useDispatch } from "react-redux";
import { addCart, delCart, setCart } from "../redux/action";
import { Link, useNavigate, useLocation } from "react-router-dom";
import api from "../utils/base_url";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { FaWhatsapp } from "react-icons/fa";
import BulkInquiryModal from "../components/BulkInquiryModal";
import '../styles/index.css';
import "../styles/Cart.css";
import { motion } from "framer-motion";

import { useCartPricing } from "../hooks/useCartPricing";

const ShowCart = ({ state, stocks, stockError, disabledQty, addItem, removeItem, formatName, initiateCheckout, navigate, openBulkModal }) => {
  const { pricingMap, subtotal, loading } = useCartPricing(state);

  return (
    <section className="h-100 gradient-custom-themed">
      <div className="container py-5">
        <div className="row d-flex justify-content-center my-4">

          <div className="col-lg-8 col-md-10 col-12 mb-4">
            <div className="card mb-4 rounded-theme shadow-theme">
              <div className="card-header py-3 cart-card-header">
                <h5 className="mb-0 cart-card-title">Item List</h5>
              </div>
              <div className="card-body p-3">
                {state.map((item) => {
                  const p = pricingMap[item.id];
                  const hasDiscount = p && p.discount_percent > 0;
                  const unitPrice = p ? p.wholesale_price : Number(item.price);
                  const original = p ? p.original_price : Number(item.price);

                  return (
                    <div key={item.id} className="mb-3 pb-3 border-bottom border-theme-light cart-clickable-item cart-item-row"
                      onClick={() => navigate(`/product/${item.id}`)}>
                      <div className="row align-items-center g-2">
                        <div className="col-4 col-sm-3 text-center">
                          <img src={item.product_image} alt={formatName(item.product_name)}
                            className="cart-product-image rounded-theme img-fluid" />
                        </div>

                        <div className="col-8 col-sm-5">
                          <p className="cart-product-title">{formatName(item.product_name)}</p>

                          {item.quantity && item.quantity_unit && (
                            <p className="cart-qty-unit">
                              {["size", "color"].includes(item.quantity_unit?.toLowerCase())
                                ? item.quantity : `${item.quantity} ${item.quantity_unit}`}
                            </p>
                          )}

                          <p className="cart-price-text">
                            ₹ {unitPrice.toLocaleString()}{" "}
                            {hasDiscount && (
                              <span className="cart-original-price">₹ {original.toLocaleString()}</span>
                            )}
                          </p>

                          {hasDiscount && (
                            <span className="cart-wholesale-badge">
                              WholeSale price applied · {p.discount_percent}% off
                            </span>
                          )}
                        </div>

                        <div className="col-12 col-sm-4 d-flex align-items-center justify-content-between justify-content-sm-end gap-2">
                          <div className="input-group input-group-sm quantity-controls">
                            <button className="btn-themed-outline" onClick={(e) => { e.stopPropagation(); removeItem(item); }}>
                              <i className={`fas fa-${item.qty > 1 ? "minus" : "trash"}`}></i>
                            </button>
                            <span className="input-group-text qty-display">{item.qty}</span>
                            <button className="btn-themed-outline" onClick={(e) => { e.stopPropagation(); addItem(item); }}
                              disabled={disabledQty[item.id]}>
                              <i className="fas fa-plus"></i>
                            </button>
                          </div>

                          <p className="cart-total-price">
                            ₹ {(unitPrice * item.qty).toLocaleString()}
                          </p>

                          {stockError[item.id] && (
                            <motion.div
                              initial={{ x: 100, opacity: 0 }}
                              animate={{
                                x: [100, 0, -6, 6, -6, 6, 0],
                                opacity: 1,
                              }}
                              transition={{
                                duration: 0.6,
                                ease: "easeOut",
                              }}
                              exit={{
                                x: -100,
                                opacity: 0,
                                transition: { duration: 0.3 }
                              }}
                              className="cart-stock-error-badge"
                            >
                              Stock limit reached!
                            </motion.div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-8 col-12 mb-4">
            <div className="card rounded-theme shadow-theme">
              <div className="card-header py-3 cart-card-header">
                <h5 className="mb-0 cart-card-title">Order Summary</h5>
              </div>
              <div className="card-body p-3">
                <ul className="list-group list-group-flush mb-3">
                  <li className="list-group-item d-flex justify-content-between px-0">
                    Product Amount
                    <span>{loading ? "Calculating…" : `₹${Math.round(subtotal).toLocaleString()}`}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between px-0 align-items-center">
                    <span>Courier Charge</span>
                    <span className="courier-note">calculated at checkout</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between px-0 fw-bold align-items-center">
                    <span>Sub Total</span>
                    <span>
                      ₹{Math.round(subtotal).toLocaleString()}{" "}
                      <span className="subtotal-note">+ courier</span>
                    </span>
                  </li>
                </ul>

                <button className="btn-themed btn-lg w-100 text-center" onClick={initiateCheckout} disabled={loading}>
                  Go to checkout
                </button>

                <button
                  type="button"
                  className="btn-cart-wholesale-whatsapp w-100 mt-2"
                  onClick={openBulkModal}
                >
                  <FaWhatsapp size={19} /> Inquire Wholesale on WhatsApp
                </button>

                <p className="delivery-helper-text">Delivery charge will be added based on your pincode</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};
const Cart = () => {

  const [stocks, setStocks] = useState({});
  const [stockError, setStockError] = useState({});
  const [disabledQty, setDisabledQty] = useState({});
  const [bulkModalOpen, setBulkModalOpen] = useState(false);

  const state = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();
  const { pricingMap } = useCartPricing(state);

  const { user } = useAuth();
  const location = useLocation();

  const addItem = (product) => {
    const availableStock = stocks[product.id];
    const nextQty = product.qty + 1;

    if (availableStock && nextQty > availableStock) {
      setStockError(prev => ({ ...prev, [product.id]: true }));
      setDisabledQty(prev => ({ ...prev, [product.id]: true }));

      setTimeout(() => {
        setStockError(prev => ({ ...prev, [product.id]: false }));
        setDisabledQty(prev => ({ ...prev, [product.id]: false }));
      }, 2000);

      return;
    }

    dispatch(addCart(product));
  };

  const navigate = useNavigate();

  const initiateCheckout = async () => {
    const token = sessionStorage.getItem("access");
    if (!token) {
      sessionStorage.setItem(
        "redirect_toast",
        "Please login first to continue checkout"
      );

      sessionStorage.setItem(
        "login_redirect",
        JSON.stringify({
          pathname: location.pathname,
          search: location.search,
          state: location.state,
        })
      );

      return navigate("/login");
    }

    const userId = user.id;
    const cartPayload = state.map((item) => ({
      product_id: item.id,
      qty: item.qty,
    }));

    try {
      const res = await api.post("checkout-initiate/", {
        user_id: userId,
        cart: cartPayload,
      });

      if (!res.data.status) {
        toast.error(res.data.message || "Checkout failed");
        return;
      }

      if (res.data.updated_items?.length || res.data.removed_items?.length) {
        toast.error("Cart updated due to stock change. Please review and click checkout again.");

        const final = res.data.reserved_items.map((i) => ({
          id: i.product_id,
          qty: i.qty,
          product_name: i.product_name,
          price: Number(i.price) || 0,
          offer_price: i.offer_price ? Number(i.offer_price) : null,
          product_image: i.product_image,
        }));

        dispatch(setCart(final));
        return;
      }

      navigate("/checkout");
    } catch (err) {
      console.error("initiateCheckout error:", err);
      toast.error("Unable to start checkout");
    }
  };

  const formatName = (text) => {
    if (!text) return "";
    const cleaned = text.replace(/_/g, " ").toLowerCase();
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  };

  const removeItem = (product) => {
    dispatch(delCart(product));
    setStockError(prev => ({ ...prev, [product.id]: false }));
  };

  const EmptyCart = () => (
    <div className="empty-cart-wrapper">
      <div className="empty-cart-card">

        <div className="empty-cart-icon">
          <i className="fas fa-shopping-bag"></i>
        </div>

        <h4 className="empty-cart-title">
          Your Cart is Empty
        </h4>

        <p className="empty-cart-subtitle">
          Looks like you haven’t added anything yet.
        </p>

        <Link
          to="/product"
          className="empty-cart-btn"
        >
          <i className="fa fa-arrow-left"></i>
          Continue Shopping
        </Link>
      </div>
    </div>
  );


  useEffect(() => {
    const getStock = async () => {
      try {
        const stockData = {};
        for (const item of state) {
          const res = await api.get(`stock/?product_id=${item.id}`);
          stockData[item.id] = res.data.stock;
        }
        setStocks(stockData);
      } catch (error) {
        console.error("Stock fetch error:", error);
      }
    };

    if (state.length > 0) {
      getStock();
    }
  }, [state]);

  return (
    <>
      <Navbar />
      <div className="cart-page">
        <div className="container my-3 py-3">
          <h1 className="cart-page-title">
            Cart
          </h1>
          <hr className="border-theme-light" />
          {state.length > 0 ? (
            <ShowCart
              state={state}
              stocks={stocks}
              stockError={stockError}
              disabledQty={disabledQty}
              addItem={addItem}
              removeItem={removeItem}
              formatName={formatName}
              initiateCheckout={initiateCheckout}
              navigate={navigate}
              openBulkModal={() => setBulkModalOpen(true)}
            />
          ) : <EmptyCart />}
        </div>
      </div>
      <Footer />

      {/* Multi-product Wholesale WhatsApp Modal */}
      <BulkInquiryModal
        isOpen={bulkModalOpen}
        onClose={() => setBulkModalOpen(false)}
        items={state.map((item) => ({
          ...item,
          wholesale_price: pricingMap?.[item.id]?.wholesale_price || null,
        }))}
      />
    </>
  );
};

export default Cart;
